module.exports = __webpack_public_path__ + "static/swimmer_demo_view-cc94962d3712cdc55838dc4a94dba741.png";